/**
 * React Query hook for the K8s Health screen.
 *
 * Polls every 15 seconds — matching the legacy dashboard's setInterval(refresh, 15000).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchK8sHealth } from '@/api/k8sHealth';

export function useK8sHealth() {
  return useQuery({
    queryKey: ['adminK8sHealth'],
    queryFn: fetchK8sHealth,
    refetchInterval: 15_000
  });
}
